import React from "react";
import { observer } from "mobx-react";
import { TenantDocumentViewStore } from "../../store";
import { TenantDocumentViewForm } from "./TenantDocumentViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type TenantDocumentViewProps = {
  tenantDocumentViewStore: TenantDocumentViewStore;
};

export const TenantDocumentView: React.FC<TenantDocumentViewProps> = observer(
  ({ tenantDocumentViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <TenantDocumentViewForm
          name={tenantDocumentViewStore.nameValue}
          description={tenantDocumentViewStore.descriptionValue}
          fileFiles={tenantDocumentViewStore.fileFiles}
          fileType={tenantDocumentViewStore.fileTypeValue}
          fileSize={tenantDocumentViewStore.fileSizeValue}
          statusOptions={tenantDocumentViewStore.getStatusOptions()}
          status={tenantDocumentViewStore.statusValue}
          chunkCount={tenantDocumentViewStore.chunkCountValue}
          uploadedAt={tenantDocumentViewStore.uploadedAtValue}
          processedAt={tenantDocumentViewStore.processedAtValue}
          processingError={tenantDocumentViewStore.processingErrorValue}
          contentType={tenantDocumentViewStore.contentTypeValue}
          chunkingStrategyOptions={tenantDocumentViewStore.getChunkingStrategyOptions()}
          chunkingStrategy={tenantDocumentViewStore.chunkingStrategyValue}
          chunkingSeparatorRegex={
            tenantDocumentViewStore.chunkingSeparatorRegexValue
          }
          chunkingMaxTokens={tenantDocumentViewStore.chunkingMaxTokensValue}
          chunkingOverlapTokens={
            tenantDocumentViewStore.chunkingOverlapTokensValue
          }
          onPrint={(handlePrint: () => void) =>
            tenantDocumentViewStore.printTenantDocument(handlePrint)
          }
          onCancel={() => tenantDocumentViewStore.cancelTenantDocument()}
          onEdit={
            tenantDocumentViewStore.isEditEnabled
              ? () => tenantDocumentViewStore.editTenantDocument()
              : undefined
          }
          fileViewAction={getViewAction(
            (props) => tenantDocumentViewStore.fileDownload(props, "file"),
            (props) => tenantDocumentViewStore.viewFilePdf(props, "file")
          )}
        />
        <ErrorDialog
          open={tenantDocumentViewStore.errorDialogOpened}
          title={tenantDocumentViewStore.errorTitle}
          description={tenantDocumentViewStore.errorDescription}
          onClose={() => tenantDocumentViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={tenantDocumentViewStore.pdfViewerOpen}
          onClose={() => tenantDocumentViewStore.closePdfViewer()}
          pdfUrl={tenantDocumentViewStore.pdfViewerUrl}
          title={tenantDocumentViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
